import HTTP from './http.js'

class LuckyCommodity extends HTTP {

  /**获取幸运饰品(分类数据), 不包括里面的饰品
  * @return {array} 分类数组
  */
  getCommodityCategory() {
    return this.request({
      url: '/after/boxgo/arms/luckyArmsCRU',
      method: 'POST'
    }).then(res => {
      if (res.code == 0) {
        return res.data
      }
    })
  }

  /** 根据幸运饰品分类 id 获取里面的饰品
   * @param {string} luckId 饰品分类ID
   * @param {string} searchQuery 饰品关键字名称
   * @param {string} sort 排除可选值:price_sort/price_desc
   * @param {string} start 饰品价格区间开始价格
   * @param {string} end 饰品价格区间结束价格
   * @param {string} page 当前页,默认:1
   * @param {string} pagesize 每页多少条默认:10
   * @return {object}  饰品分类的详细数据
   */
  getCommodityList(options) {
    if (!options.luckId) {
      throw new Error('饰品分类luckId不能为空')
    }

    return this.request({
      url: '/after/boxgo/arms/getArmsListByLuckId',
      method: 'POST',
      data: options
    }).then(res => {
      if (res.code == 0) {
        return res.data
      }
    })

  }
}

export default LuckyCommodity